.option-container {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.option-title {
    padding-left: 8px;
}
